import React from 'react';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';
import { customEvent } from '@utils/customEvent';

import './SinkingModal.less';


export class SinkingModal extends CommonComponent {
  constructor(props) {
    super(props);

    this.state = {
      sinkingModalData: {
        showModal: false, // 是否显示弹窗
        isSinking: false, // 是否下沉动画
        pushContent: '',  // 推送内容
        eventParams: {}   // 点击事件
      }
    }
  }

  componentDidMount(){
    this.getUserSetNoticesList();
  }


   // 获取用户设置的下沉弹窗信息
   getUserSetNoticesList = () => {
    let that = this;
    let newData = {};
    app.sendRequest({
      url: '/index.php?r=EventMessage/GetEventNoticeList',
      hideLoading: true,
      success: function (res) {
        let noticesData = res.data;
        let isEmpty = !noticesData || JSON.stringify(noticesData) === '[]' || JSON.stringify(noticesData) === '{}';
        if (isEmpty) {
          return false;
        }
        // 弹窗id
        newData['sinkingModalData.id'] = res.id;
        // 点击事件的参数
        let eventParams = noticesData.page_url;
        eventParams = typeof eventParams === 'string' ? JSON.parse(eventParams) : eventParams;
        newData['sinkingModalData.eventParams'] = eventParams;
        // 是否显示弹窗
        newData['sinkingModalData.showModal'] = true;
        // 是否有下沉动画
        newData['sinkingModalData.isSinking'] = true;
        // 推送文案
        newData['sinkingModalData.pushContent'] = noticesData.content || '';
        that.setData(newData);
        // 弹窗2s后消失
        setTimeout(function () {
          that.setData({
            'sinkingModalData.isSinking': false,
          });
        }, 3000);
      },
      fail: function (res) {
        console.log(res);
      }
    });
  }

  // 用户设置的点击事件跳转
  tapEventCommonHandler = (e) => {
    let id = this.data.sinkingModalData.id || '';
    let { eventParams } = e.currentTarget.dataset;
    eventParams = JSON.parse(eventParams);
    app.sendRequest({
      url: '/index.php?r=EventMessage/SetMsgReadById',
      hideLoading: true,
      data: {
        'msg_id': id
      },
      success:  () => {
        if (eventParams && eventParams.action && eventParams.action != 'none') {
          customEvent({
            customFeature: eventParams
          })
        }
      }
    });
  }


  render(){
    let { sinkingModalData } = this.state;
    if(!sinkingModalData.showModal){
      return null;
    }
    return (
      <div className={`common-component sinking-modal-wrap ${ sinkingModalData.isSinking ? 'show-modal' : 'hide-modal' }`} onClick={this.tapEventCommonHandler}  data-event-params={JSON.stringify(sinkingModalData.eventParams)}>
        <div className="sinking-modal">
          <span className="tip-txt">{sinkingModalData.pushContent}</span>
          { sinkingModalData.eventParams && <span className="btn-txt">查看</span> }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/common/sinking-modal/SinkingModal.jsx